import React, { useEffect } from "react";
import { useAutocomplete } from "@mui/base/useAutocomplete";
import useAirports from "../hooks/useAirports";
import Divider from "@mui/material/Divider";
import Input from "@mui/material/Input";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import InputAdornment from '@mui/material/InputAdornment';

export default function AirportAutocomplete({ label, error, onChange, adornment }) {
  const { airports, getAirports } = useAirports();
  const {
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    inputValue,
  } = useAutocomplete({
    id: "airport-autocomplete",
    options: airports,
    getOptionLabel: (option) => option.name,
    filterOptions: (x) => x,
  });

  useEffect(() => {
    getAirports(inputValue);
  }, [inputValue]);

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <>
      <div {...getRootProps()}>
        <Input
          inputProps={getInputProps()}
          placeholder={label}
          error={error}
          required
          color="secondary"
          startAdornment={
            <InputAdornment position="start">
              {adornment}
            </InputAdornment>
          }
          className="input-autocomplete"
        />
      </div>
      {groupedOptions.length > 0 ? (
        <Paper
          elevation={1}
          sx={{
            width: 360,
            overflow: "auto",
            maxHeight: 300,
            bgcolor: "background.paper",
            position: "absolute",
            zIndex: 999,
          }}
        >
          <List {...getListboxProps()}>
            {groupedOptions.map((option, index) => (
              <React.Fragment key={index}>
                <ListItem {...getOptionProps({ option, index })} disablePadding>
                  {option.type === "country" ? (
                    <ListItemText
                      primary={option.name}
                      primaryTypographyProps={{
                        fontWeight: "medium",
                        paddingLeft: 2,
                      }}
                    />
                  ) : (
                    <ListItemButton>
                      <ListItemText
                        primary={option.name}
                        secondary={
                          option.type === "any"
                            ? undefined
                            : `${option.iata}, ${option.city}`
                        }
                      />
                    </ListItemButton>
                  )}
                </ListItem>
                {index < groupedOptions.length - 1 && <Divider sx={{ margin: 0 }} />}
              </React.Fragment>
            ))}
          </List>
        </Paper>
      ) : null}
    </>
  );
}
